import React, { memo, useCallback } from 'react';

const ScrollElementTop = ({ element }) => {
	const scrollElement = useCallback(() => element.scrollTo({ top: 0, behavior: 'smooth' }), [element]);

	return <i className='fas fa-caret-square-up bg-light text-warning scroll-to-top' onClick={scrollElement} />;
};

export default memo(ScrollElementTop);
